import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/questionnaire-template']['GET'];
type Input = ThisApi['params'];

const getQuestionnaireTemplateOfQuestionnaire = async ({ questionnaireId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/questionnaire-template', { questionnaireId });
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getQuestionnaireTemplateOfQuestionnaire;
